import { ErrorStateMatcher } from "@angular/material/core";
import { FormControl } from "@angular/forms";
import { Injectable } from "@angular/core";

/**
 * Display error on form inputs when control is invalid.
 */
@Injectable()
export class ShowOnInvalidErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl<boolean | null> | null): boolean {
    if (!control) {
      return false;
    }
    const hasInteraction = control.touched || control.dirty;
    const isInvalid = control.invalid;
    return !!(hasInteraction && isInvalid);
  }
}
